'use client';

import type React from 'react';
import { useTranslation } from '../../hooks/useTranslations';
import { EMAIL } from '../../constants/routes';
import Image from 'next/image';
import './page.scss';

export default function TermsPage() {
  const { t } = useTranslation();

  const renderWithEmailAndHTML = (text: string) => {
    const emailReplaced = text.replace(EMAIL, `__EMAIL_PLACEHOLDER__`);
    const htmlString = emailReplaced.replace(
      /__EMAIL_PLACEHOLDER__/g,
      `<a href="mailto:${EMAIL}" class="terms-page__email">${EMAIL}</a>`
    );
    return htmlString;
  };

  return (
    <>
      <div className="terms-page">
        <div className="terms-page__hero-section">
          <div className="terms-background">
            <Image
              src="/privacy-bg.png"
              alt="Background"
              fill
              priority
              className="terms-background__image"
            />
          </div>
          <div className="terms-page__content">
            <div className="terms-page__container">
              <h1 className="terms-page__title">{t('terms.title')}</h1>
              <p className="terms-page__updated">{t('terms.updated')}</p>

              <div className="terms-page__text">
                <h2 className="terms-page__subtitle">{t('terms.subtitle')}</h2>
                <p>{t('terms.intro1')}</p>
                <p>{t('terms.intro2')}</p>
                <p>{t('terms.intro3')}</p>

                <h2>{t('terms.aboutShift.title')}</h2>
                <p>{t('terms.aboutShift.content')}</p>

                <h2>{t('terms.usingApp.title')}</h2>
                <p>{t('terms.usingApp.content1')}</p>
                <p>{t('terms.usingApp.content2')}</p>

                <h2>{t('terms.registration.title')}</h2>
                <p>{t('terms.registration.subtitle')}</p>
                <ul>
                  {(
                    t('terms.registration.items', {
                      returnObjects: true,
                    }) as string[]
                  ).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                <h2>{t('terms.businessRegistration.title')}</h2>
                <p>{t('terms.businessRegistration.subtitle')}</p>
                <ul>
                  {(
                    t('terms.businessRegistration.items', {
                      returnObjects: true,
                    }) as string[]
                  ).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p>{t('terms.businessRegistration.content1')}</p>

                <h2>{t('terms.accountSecurity.title')}</h2>
                <p>{t('terms.accountSecurity.content1')}</p>
                <p>{t('terms.accountSecurity.content2')}</p>

                <h2>{t('terms.hiringWorks.title')}</h2>
                <p>{t('terms.hiringWorks.content1')}</p>
                <p>{t('terms.hiringWorks.content2')}</p>

                <h2>{t('terms.feesPayments.title')}</h2>
                <ul>
                  {(
                    t('terms.feesPayments.items', {
                      returnObjects: true,
                    }) as string[]
                  ).map((item: string, index: number) => (
                    <li
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  ))}
                </ul>

                <h2>{t('terms.contentSubmit.title')}</h2>
                <p>{t('terms.contentSubmit.content')}</p>

                <h2>{t('terms.dataPrivacy.title')}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('terms.dataPrivacy.content'),
                  }}
                />

                <h2>{t('terms.marketing.title')}</h2>
                <p>{t('terms.marketing.content')}</p>

                <h2>{t('terms.intellectualProperty.title')}</h2>
                <p>{t('terms.intellectualProperty.content')}</p>

                <h2>{t('terms.limitationLiability.title')}</h2>
                <p>{t('terms.limitationLiability.content1')}</p>
                <p>{t('terms.limitationLiability.content2')}</p>

                <h2>{t('terms.prohibitedUses.title')}</h2>
                <p>{t('terms.prohibitedUses.subtitle')}</p>
                <ul>
                  {(
                    t('terms.prohibitedUses.items', {
                      returnObjects: true,
                    }) as string[]
                  ).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                <h2>{t('terms.endingAccount.title')}</h2>
                <p>{t('terms.endingAccount.content')}</p>

                <h2>{t('terms.updatesTerms.title')}</h2>
                <p>{t('terms.updatesTerms.content')}</p>

                <h2>{t('terms.governingLaw.title')}</h2>
                <p>{t('terms.governingLaw.content')}</p>

                <h2>{t('terms.contact.title')}</h2>
                <p>{t('terms.contact.content')}</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: renderWithEmailAndHTML(t('terms.contact.email')),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
